/* eslint import/prefer-default-export: 0 */

export const application = {
  destination: {
    comments: 'Additional Comments',
    attachments: 'Attachments',
    submit: 'Submit',
    review: 'Submit',
  },
  header: [
    '# All required fields are complete',
    'Not a guarantee of acceptance. We are checking that all required fields are complete',
  ],
  additional: [
    '### Additional comments',
    'After completing this form and any attachments, you should review your answers to all questions to make sure the form is complete and accurate, and then sign and date the following certification and the following release(s). You will not be able to submit until each release below is signed',
  ],
  validForm: {
    certificationItem: 'Certification',
    generalItem: 'Release of Information & HIPAA',
    general85Item: 'Release of Information',
    creditItem: 'Credit reporting disclosure',
    submit: 'Submit your {{formName}}',
    next: 'Go to next release',
    submitting: 'Submitting form...',
  },
  invalidForm: [
    '### List of incomplete sections',
    'Use the list below to complete all incomplete sections or sections with errors.',
  ],
  submissionConfirmation: {
    para: [
      '**Once you submit, your form will be locked** and you will no longer be able to make changes.',
      'After submission you will be able to download a copy of your completed {{formName}} and all signed certification and released documents.',
      '**Are you sure you are ready to submit your {{formName}}?**',
    ],
    back: 'Back to review',
    submit: 'Submit',
    timeNotification: 'Note that the time you certify your submission will be recorded using Coordinated Universal Time (UTC), regardless of your current time zone. UTC is a standardized time system that ensures global consistency.',
    serverTime: 'The server\'s current UTC time is:  ',
  },
  hipaaConfirmation: {
    header: '**Notice - **Your Medical release form has not been signed.',
    para: [
      'While you are not required to sign the Medical release form in order to submit your form, please be aware that continuing without signing the release may have an impact on your investigation. You can return to further review the releases by pressing Back to Review. If you would like to continue without signing your Medical release form, you may proceed by pressing Continue.',
      '**Would you like to proceed without signing your Medical release form?**'
    ],
    back: 'Back to review',
    continue: 'Continue',
  },
  submissionStatus: {
    validating: ['# Verifying your information is complete', 'Checking your form...'],
    valid: [
      '# All required fields are complete',
      'Not a guarantee of acceptance, but all required fields are complete.',
    ],
    valid2: ['### Please sign the releases below and submit your form'],
    invalid: ['# Some required fields are incomplete', 'Please fix the errors listed below.'],
  },
  submissionComplete: [
    '## You are done!',
    '### Thanks for submitting your SF-86',
    'Please print and save your submission below, they will be your only copies',
  ],
  print: {
    title: [
      '## Please print and save your responses',
      '**This will be your only opportunity.** Your form will be locked when you logout. Be sure to print and save your responses before leaving this screen. To save a PDF click the Save/Print button then change the printer "Destination" to "Save as PDF".',
    ],
    button: 'Save/Print',
    done: [
      '## You are done!',
      '### Thanks for submitting for your SF-86',
      'If you need assistance contact the office who initiated your form.',
    ],
    files: {
      title: 'Certification and Releases',
      para:
        'The following are archival documents corresponding to your digitally signed certification and releases.',
    },
  },
  attachments: {
    method: {
      title: 'Specify your attachment method',
      para: 'Choose the method you will use to provide attachments for your Investigation Request.',
    },
    type: {
      upload: 'Upload file',
      fax: 'Direct fax',
      other: 'Other',
    },
    help: {
      title: 'Need help with the attachment methods?',
      message: [
        '**Upload file**',
        'Upload to e-QIP directly - scan and electronically upload directly to your e-QIP request.',
        '*Must be done prior to releasing the request*',
        '**Direct fax**',
        'Fax attachment to e-QIP directly, e-QIP offers an automated fax solution to attach a fax to your Investigation Request. Print a cover sheet and fax to the telephone number listed on the cover sheet.',
        '*Must be done prior to releasing the request*',
        '**Other**',
        'Standard Fax, Mail, or Other - if not using one of the two methods above indicate how you plan to provide each attachment.',
      ],
      note: '',
    },
    upload: {
      title: 'Upload file to e-QIP directly',
      para: [
        'Certification, General Release and Medical Release forms must be attached separately as single page documents. Items such as a resume or OF 612 can be uploaded as multi-page documents.',
      ],
      limits: '{types} files only. Maximum file size allowed is {max_size}.',
      description: 'Description',
      send: 'Upload attachment',
      files: {
        title: 'Uploaded files',
        para:
          'The following documents and/or files have been associated with your Investigation Request.',
        remove: 'Remove',
      },
      error: {
        title: 'We had a problem with your attachment!',
        delete: 'Failed to delete attachment.',
        download: 'Failed to download attachment.',
        save: 'Failed to save attachment. Please check the size and type of attachment.',
        update: 'Failed to save attachment description.',
      },
    },
    fax: {
      title: 'Direct fax',
      para: [
        'Fax attachment to e-QIP directly, e-QIP offers an automated fax solution to attach a fax to your Investigation Request. Print a cover sheet and fax to the telephone number listed on the cover sheet.',
        '*Must be done prior to releasing the request.*',
      ],
      print: 'Print cover sheet',
    },
    other: {
      title: 'Other',
      para: [
        'Standard Fax, Mail, or Other - if not using one of the two methods above indicate how you plan to provide each attachment.',
      ],
      method: 'Specify other attachment method',
      address: 'Mailing address',
    },
  },
  hashCode: {
    title: 'Data hash code',
  },
  alert: {
    navigation: 'Your form has been submitted and is locked',
    logout: 'Make sure you save and/or print your responses before logging out',
    notApplicable: 'This will remove any data currently entered. Would you like to continue?',
  },
  loading: {
    title: '#### We are loading your data',
    error: {
      title: 'Oops, there’s a problem.',
      para: ['There was a problem loading your data, please try again.'],
      button: 'Back to login',
    },
  },
  timeout: {
    title: 'Are you still working?',
    message: 'Let us know below or you will be logged out in {time} seconds.',
    button: "Yes I'm still working",
    aria: "Select the yes I'm still working button or you will be logged out in {time} seconds.",
  },
  newTab: {
    title: 'You already have a session open in this browser',
    message: 'You have either attempted to refresh the page from the browser or have opened a new browser tab/window. Please close this tab and continue the current session or reload the form.',
  },
  kickbackWarning: {
    title: 'Oops! Something went wrong while loading the website.',
    message: 'We apologize for the inconvenience. Please try logging out and then logging back in. This may resolve the issue you encountered. If the problem persists, you can choose to continue without pre-filled information by selecting the "Bypass and Continue" option.',
    assistance: 'If you need further assistance, feel free to contact our support team for help in resolving the issue. Thank you for your understanding.',
    button: 'Bypass and Continue',
    aria: 'Select the continue to the form button or log out and log back in to try again',
    logout: 'Logout',
    logoutAria: 'Click to log out',
  },
};
